import { render, staticRenderFns } from "./UserProfileActivitiesSection.vue?vue&type=template&id=f179d448&scoped=true"
import script from "./UserProfileActivitiesSection.vue?vue&type=script&lang=js"
export * from "./UserProfileActivitiesSection.vue?vue&type=script&lang=js"
import style0 from "./UserProfileActivitiesSection.vue?vue&type=style&index=0&id=f179d448&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f179d448",
  null
  
)

export default component.exports